/* SOYUL fit finder — recommendation based on manufacturer height/weight hints and optional jacket comparison. */
(() => {
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function parseRows(raw) {
    return (raw || '').split(';').map((row) => {
      const parts = row.split('|');
      return {
        size: (parts[0] || '').trim(),
        bust: Number((parts[1] || '').replace(',', '.')),
        sleeve: Number((parts[2] || '').replace(',', '.')),
        fourth: Number((parts[3] || '').replace(',', '.')),
        length: Number((parts[4] || '').replace(',', '.')),
        refHeight: Number((parts[5] || '').replace(',', '.')),
        refWeight: Number((parts[6] || '').replace(',', '.')),
      };
    }).filter((x) => x.size && Number.isFinite(x.bust) && x.bust > 0);
  }

  function applyPreference(index, count, pref) {
    if (pref === 'very_relaxed') return clamp(index + 1, 0, count - 1);
    if (pref === 'relaxed') return clamp(index, 0, count - 1);
    if (pref === 'close') return clamp(index, 0, count - 1);
    if (pref === 'very_close') return clamp(index - 1, 0, count - 1);
    return clamp(index, 0, count - 1);
  }

  function preferenceLabel(pref) {
    return {
      very_close: 'près du corps',
      close: 'ajusté',
      standard: 'standard',
      relaxed: 'un peu ample',
      very_relaxed: 'ample / oversize'
    }[pref] || 'standard';
  }

  function init(root) {
    if (root.dataset.fitReady) return;
    root.dataset.fitReady = 'true';
    const el = (key) => root.querySelector('[data-fit-' + key + ']');
    const result = el('result');
    const rows = parseRows(root.dataset.sizeRows);

    el('calculate').addEventListener('click', () => {
      const height = Number((el('height').value || '').replace(',', '.'));
      const weight = Number((el('weight').value || '').replace(',', '.'));
      const reference = Number((el('reference').value || '').replace(',', '.'));
      const pref = el('preference').value || 'standard';
      const hasHW = Number.isFinite(height) && height >= 120 && height <= 215 && Number.isFinite(weight) && weight >= 25 && weight <= 250;
      const hasRef = Number.isFinite(reference) && reference >= 35 && reference <= 110;

      result.hidden = false;
      result.replaceChildren();

      const title = document.createElement('strong');
      const body = document.createElement('p');
      const note = document.createElement('p');
      note.className = 'soyul-fit-finder__result-note';

      if (!rows.length) {
        title.textContent = 'Conseil indisponible';
        body.textContent = 'Les mesures de ce modèle ne sont pas encore exploitables pour une recommandation. Utilisez le tableau juste en dessous.';
        result.append(title, body);
        return;
      }

      if (!hasHW && !hasRef) {
        title.textContent = 'Ajoutez au moins 2 informations';
        body.textContent = 'Entrez votre taille et votre poids, ou bien la largeur à plat d’une veste qui vous va bien.';
        note.textContent = 'Le conseil reste indicatif : vérifiez toujours la poitrine, les manches et la longueur.';
        result.append(title, body, note);
        return;
      }

      let scored = rows.map((row, index) => {
        let score = 0;
        if (hasHW && Number.isFinite(row.refHeight) && Number.isFinite(row.refWeight) && row.refHeight > 0 && row.refWeight > 0) {
          score += Math.abs(row.refHeight - height) * 1.15;
          score += Math.abs(row.refWeight - weight) * 2;
        } else if (hasHW) {
          // Slightly prefer the middle when no HW manufacturer hints are available.
          score += Math.abs(index - Math.floor(rows.length / 2)) * 4;
        }
        if (hasRef) {
          const targetBust = reference * 2;
          score += Math.abs(row.bust - targetBust) * 1.5;
        }
        return { row, index, score };
      }).sort((a, b) => a.score - b.score);

      let winnerIndex = scored[0].index;
      winnerIndex = applyPreference(winnerIndex, rows.length, pref);
      const winner = rows[winnerIndex];
      const altDown = winnerIndex > 0 ? rows[winnerIndex - 1] : null;
      const altUp = winnerIndex < rows.length - 1 ? rows[winnerIndex + 1] : null;

      title.textContent = 'Taille conseillée : ' + winner.size;

      const pieces = [];
      if (hasHW && Number.isFinite(winner.refHeight) && Number.isFinite(winner.refWeight) && winner.refHeight > 0 && winner.refWeight > 0) {
        pieces.push('Pour ' + height.toLocaleString('fr-FR') + ' cm et ' + weight.toLocaleString('fr-FR') + ' kg, le repère fabricant le plus proche est ' + winner.size + '.');
      } else if (hasHW) {
        pieces.push('Votre taille et votre poids orientent vers ' + winner.size + '.');
      }
      if (hasRef) {
        pieces.push('La poitrine du vêtement en ' + winner.size + ' est de ' + winner.bust.toLocaleString('fr-FR') + ' cm, à comparer avec votre veste de référence (' + (reference * 2).toLocaleString('fr-FR') + ' cm environ).');
      }
      if (!pieces.length) {
        pieces.push('Le profil saisi oriente vers ' + winner.size + '.');
      }
      body.textContent = pieces.join(' ');

      const options = [];
      if (altDown && ['very_close'].includes(pref)) options.push('Si vous aimez vraiment porter près du corps, regardez aussi ' + altDown.size + '.');
      if (altUp && ['relaxed', 'very_relaxed'].includes(pref)) options.push('Si vous voulez encore plus de volume, regardez aussi ' + altUp.size + '.');
      if (!options.length && altDown && altUp) options.push('Entre deux rendus ? Comparez aussi ' + altDown.size + ' et ' + altUp.size + ' dans les cartes ci-dessous.');
      options.push('Vérifiez toujours la poitrine, les manches et la longueur avant de valider votre taille.');
      note.textContent = options.join(' ');

      result.append(title, body, note);
    });
  }

  function boot(context) { (context || document).querySelectorAll('[data-soyul-fit-finder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
